import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  isAuthenticated: !!sessionStorage.getItem('authToken'),
  token: sessionStorage.getItem('authToken'),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state: AuthState, action: PayloadAction<string>) => {
      state.token = action.payload;
      state.isAuthenticated = true;
      state.error = null;
      // Store token in sessionStorage
      sessionStorage.setItem('authToken', action.payload);
    },
    clearToken: (state: AuthState) => {
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      // Remove token from sessionStorage
      sessionStorage.removeItem('authToken');
    },
    setAuthLoading: (state: AuthState, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setAuthError: (state: AuthState, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    logout: (state: AuthState) => {
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      sessionStorage.removeItem('authToken');
    },
    logoutSuccess: (state: AuthState) => {
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      sessionStorage.removeItem('authToken');
    },
  },
});

export const { 
  setToken, 
  clearToken, 
  setAuthLoading, 
  setAuthError, 
  logout,
  logoutSuccess
} = authSlice.actions;
export default authSlice.reducer;
